import { useState } from "react";
import { Calendar } from "@/shared/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover"
import { Button } from "@/shared/ui/button"
import { cn } from "@/lib/utils"
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";

const DateInput = ({ name, value, onChange, placeholder }) => {
  const dateValue = value ? new Date(value) : null;
  const [open, setOpen] = useState(false);

  const handleDateSelect = (date) => {
    const syntheticEvent = {
      target: {
        name,
        value: date ? format(date, "yyyy-MM-dd") : ""
      }
    };
    onChange(syntheticEvent);
    setOpen(false);
};

  return (
    <div className="relative w-full">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-full h-10 px-3 py-2 text-sm font-SuisseIntlLight text-left font-normal rounded-md border border-slate-200 bg-white ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#71717a] focus-visible:ring-offset-1 hover:bg-white hover:border-slate-200",
              !dateValue && "text-[#71717a] font-medium"
            )}
          >
            {dateValue ? (
              format(dateValue, "PP")
            ) : (
              <span className="text-[#71717a] font-medium">{placeholder}</span>
            )}
            <CalendarIcon className="ml-auto h-4 w-4 text-[#71717a]" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" disablePortal>
          <Calendar
            mode="single"
            selected={dateValue}
            onSelect={handleDateSelect}
            defaultMonth={dateValue || new Date()}
            disabled={(date) =>
              date > new Date() || date < new Date("1900-01-01")
            }
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export { DateInput };